// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-top {
  margin-top: 30px;
}

.rolAlert {
  border-radius: 10px;
}

.userTitle {
  font-size: 20px;
}

.border {
  border: 3px solid black;
  padding: 30px;
  height: 100%;
  box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);
}

.infoDiv {
  padding: 30px;
}

.roleTitle {
  padding-left: 30px;
  width: 25%;
}

@media (max-width: 450px) {
  .roleTitle {
    width: 100%;
  }
}

.mButton {
  margin-bottom: 1rem;
}

.alertWidth {
  width: 50%;
  margin-right: 10px;
}

@media (max-width: 450px) {
  .alertWidth {
    width: 100%;
  }
}

.flex {
  display: flex;
}

.flexAlert {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
}

.flexCard {
  flex-wrap: wrap;
  justify-content: center;
}

@media (max-width: 450px) {
  .flex {
    display: block;
  }
}

.alertDanger {
  width: 30%;
}

.cardBodyHome {
  border-radius: 1rem;
  background: lightblue;
  width: 45%;
  padding: 20px;
  margin: 20px;
  box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);
}

.info-role {
  color: #ffff !important;
  background-color: #0ea293;
  border-color: #0ea293;
  border-radius: 30px;
  padding: 15px;
}

@media (max-width: 450px) {
  .cardBodyHome {
    padding: 10px;
    margin: 10px;
    width: 90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Welcome/welcome.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,+CAA+C;EAC/C,uDAAuD;EACvD,oDAAoD;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,+CAA+C;EAC/C,uDAAuD;EACvD,oDAAoD;AACtD;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,UAAU;EACZ;AACF","sourcesContent":[".title-top {\n  margin-top: 30px;\n}\n\n.rolAlert {\n  border-radius: 10px;\n}\n\n.userTitle {\n  font-size: 20px;\n}\n\n.border {\n  border: 3px solid black;\n  padding: 30px;\n  height: 100%;\n  box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);\n  -webkit-box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);\n}\n\n.infoDiv {\n  padding: 30px;\n}\n\n.roleTitle {\n  padding-left: 30px;\n  width: 25%;\n}\n\n@media (max-width: 450px) {\n  .roleTitle {\n    width: 100%;\n  }\n}\n\n.mButton {\n  margin-bottom: 1rem;\n}\n\n.alertWidth {\n  width: 50%;\n  margin-right: 10px;\n}\n\n@media (max-width: 450px) {\n  .alertWidth {\n    width: 100%;\n  }\n}\n\n.flex {\n  display: flex;\n}\n\n.flexAlert {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  flex-direction: column;\n}\n\n.flexCard {\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n@media (max-width: 450px) {\n  .flex {\n    display: block;\n  }\n}\n\n.alertDanger {\n  width: 30%;\n}\n\n.cardBodyHome {\n  border-radius: 1rem;\n  background: lightblue;\n  width: 45%;\n  padding: 20px;\n  margin: 20px;\n  box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);\n  -webkit-box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 9px 9px 30px 1px rgba(0, 0, 0, 0.2);\n}\n\n.info-role {\n  color: #ffff !important;\n  background-color: #0ea293;\n  border-color: #0ea293;\n  border-radius: 30px;\n  padding: 15px;\n}\n\n@media (max-width: 450px) {\n  .cardBodyHome {\n    padding: 10px;\n    margin: 10px;\n    width: 90%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
